export default "__VITE_ASSET__48e88428__"